module.exports = __webpack_public_path__ + "static/media/signStreamQR.e77351aa.png";